<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter4">
<h1><a id="page_22"></a><a href="#/003toc#ch4">Turkey Carcass Broth</a></h1>
<p class="noindent">I teach a lot of Thanksgiving classes. At the end of each class, after the students have tasted the Thanksgiving dinner and we are looking at the naked turkey carcass, I tell my pupils that if they can’t stand to make turkey soup after the Thanksgiving meal, to put the carcass in a two-gallon zipper-top plastic bag and freeze it. When they are ready to make turkey soup, they can just defrost it overnight in the refrigerator and put it in the slow cooker the next day. Once you have turkey stock in the freezer, you can make soup, casseroles, and all manner of sauces. This same formula can be used for chicken as well, but if you are only using one chicken, cut the ingredients in half.</p>
<p class="noindent">1 turkey carcass, broken up into pieces</p>
<p class="noindent">2 medium onions, coarsely chopped</p>
<p class="noindent">3 medium carrots, coarsely chopped</p>
<p class="noindent">3 medium stalks celery with leaves, coarsely chopped</p>
<p class="noindent">8 cups chicken stock</p>
<p class="noindent">2 teaspoons dried thyme</p>
<p class="noindent">1 teaspoon dried sage leaves</p>
<p class="noindent">1 bay leaf</p>
<p class="noindent">4 whole black peppercorns</p>
<p class="noindent">Salt</p>
<p class="noindent">put all the ingredients except the salt in the insert of a 5- to 7-quart slow cooker. Cover and cook on high for 4 to 5 hours or on low for 8 to 10 hours.</p>
<p class="noindent">season with salt. Strain the broth through a colander to remove the large solids, then strain again through a finemesh sieve.</p>
<p class="noindent">cool the stock to room temperature, then store in airtight containers in the refrigerator for up to 5 days or in the freezer for up to 6 months.</p>
<p class="noindent">makes about 8 cups</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/> slow-cooker savvy</p>
<p class="noindent">I generally don’t save the meat from this stock. It doesn’t freeze well, and since it’s now been cooked twice, it’s pretty soft and not very appetizing.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010-chapter4.vue?d97b9880